@if (bunkeringDeliveryNote) {
  <div class="row">
    <div class="col-md-6">
      <fieldset style="border: 0;"
        [disabled]="!hasRole('vessels-delivery-note-editor')">
        <form #BunkeringDeliveryNote="ngForm" class="form-horizontal">
          <div class="card shadow-sm">
            <div class="card-body">
              <div class="form-group row">
                <app-material-pg-input
                  type="text"
                  label="BDN NO"
                  name="number"
                  id="number"
                  tabindex="1"
                  [disabled]="disable"
                  [(ngModel)]="bunkeringDeliveryNote.bdnNumber">
                </app-material-pg-input>
              </div>
              <div class="form-group row">
                @if (!disable) {
                  <div>
                    <app-material-auto-complete
                      name="vessel"
                      id="rank"
                      [formatter]="vesselFormatter"
                      [(ngModel)]="selectedVessel"
                      [items]="vessels"
                      [placeholder]="'Vessel '"
                      tabindex="2"
                      [required]="true">
                    </app-material-auto-complete>
                  </div>
                }
                @if (disable) {
                  <div>
                    <app-material-pg-input
                      class="col-md-12"
                      label="Vessel"
                      type="string"
                      name="vessel1"
                      id="vessel1"
                      [disabled]="disable"
                      [(ngModel)]="bunkeringDeliveryNote.vesselName">
                    </app-material-pg-input>
                  </div>
                }
              </div>
              <div class="form-group row ">
                <div class="col-md-6 mb-3 mb-md-0">
                  <app-material-organisation-selector
                    id="location"
                    class="pg-component"
                    [(ngModel)]="selectedPortOrganisation"
                    [organisationLanguage]="'en'"
                    name="location"
                    [organisations]="ports"
                    [disabled]="disable"
                    tabindex="3"
                    [placeholder]="'Location'"
                    [required]="true">
                  </app-material-organisation-selector>
                </div>
                <div class="col-md-6">
                  <app-material-offset-date-time
                    name="date"
                    label="Date"
                    type="date"
                    [zoneId]="selectedPortOrganisation?.timezone ?? 'UTC'"
                    [(ngModel)]="bunkeringDeliveryNote.date!"
                    [disabled]="disable || !selectedPortOrganisation"
                    >
                  </app-material-offset-date-time>
                </div>
              </div>
              <div class="form-group row">
                  <app-material-auto-complete
                    name="Product"
                    id="Product"
                    [disabled]="disable"
                    [placeholder]="'Product'"
                    tabindex="5"
                    [(ngModel)]="bunkeringDeliveryNote.product"
                    [items]="productName"
                    [formatter]="productFormatter"
                    [required]="true">
                  </app-material-auto-complete>
              </div>
              <div class="form-group row">
                <app-material-pg-input
                  label="Quantity"
                  type="number"
                  name="quantity"
                  id="quantity"
                  [(ngModel)]="bunkeringDeliveryNote.quantity"
                  tabindex="5"
                  >
              </app-material-pg-input>
            </div>
            <div class="form-group row ">
              <app-material-organisation-selector
                id="supplier"
                class="pg-component"
                [(ngModel)]="selectedSupplierOrganisation"
                [organisationLanguage]="'en'"
                name="supplier"
                [organisations]="supplier"
                tabindex="7"
                [placeholder]="'Supplier'"
                [required]="true"
                >
              </app-material-organisation-selector>
            </div>
            <div class="form-group row">
              <app-material-chunk-file-uploader
                [accept]="'.pdf'"
                id="bdnFile"
                name="bdnFile"
                [label]="'BDN'"
                [(ngModel)]="doc"
                (ngModelChange)="uploadBDNFile($event)"
                [required]="!doc"
                tabindex="8">
              </app-material-chunk-file-uploader>
            </div>
            <div class="form-group row">
              <app-material-pg-input
                  class="col-md-6 mb-3 mb-md-0"
                  label="Viscosity"
                  type="number"
                  name="Viscosity"
                  id="Viscosity"
                  [(ngModel)]="bunkeringDeliveryNote.spec!.viscosity">
                </app-material-pg-input>
                <app-material-pg-input
                  class="col-md-6"
                  label="Density"
                  type="number"
                  name="Density"
                  id="Density"
                  tabindex="12"
                  [(ngModel)]="bunkeringDeliveryNote.spec!.density"
                  >
              </app-material-pg-input>
            </div>
            <div class="form-group row">
              <app-material-pg-input
                  class="col-md-6 mb-3 mb-md-0"
                  label="Water"
                  type="number"
                  name="Water"
                  id="Water"
                  tabindex="13"
                  [(ngModel)]="bunkeringDeliveryNote.spec!.water"
                  >
              </app-material-pg-input>
              <app-material-pg-input
                  class="col-md-6"
                  label="Sulphur"
                  type="number"
                  name="Sulphur"
                  id="Sulphur"
                  tabindex="14"
                  [(ngModel)]="bunkeringDeliveryNote.spec!.sulphur"
                  >
              </app-material-pg-input>
            </div>
            <div class="form-group row">
              <app-material-pg-input
                  class="col-md-6 mb-3 mb-md-0"
                  label="Flash Point"
                  type="number"
                  name="Flash Point"
                  id="Flash Point"
                  tabindex="15"
                  [(ngModel)]="bunkeringDeliveryNote.spec!.flashPoint"
                  >
              </app-material-pg-input>
              <app-material-pg-input
                  class="col-md-6"
                  label="Prior Rob"
                  type="number"
                  name="priorRob"
                  id="priorRob"
                  [(ngModel)]="bunkeringDeliveryNote.priorRob"
                  >
              </app-material-pg-input>
            </div>
            <div class="form-group row">
              <div class="col-md-6">
                <app-material-offset-date-time
                  name="Along Side"
                  label="Along Side"
                  type="datetime-local"
                  [zoneId]="selectedPortOrganisation?.timezone!"
                  [(ngModel)]="bunkeringDeliveryNote.sof!.alongside"
                  [maxDate]="bunkeringDeliveryNote?.date?.isoDate!"
                  [disabled]="!selectedPortOrganisation"

                >
                </app-material-offset-date-time>
              </div>
              <div class="col-md-6">
                <app-material-offset-date-time
                  name="Hose Connected"
                  label="Hose Connected"
                  type="datetime-local"
                  [zoneId]="selectedPortOrganisation?.timezone!"
                  [(ngModel)]="bunkeringDeliveryNote.sof!.hoseConnected"
                  [minDate]="bunkeringDeliveryNote?.sof?.alongside?.isoDate!"
                  [maxDate]="bunkeringDeliveryNote?.date?.isoDate!"
                  [disabled]="!selectedPortOrganisation || !bunkeringDeliveryNote?.sof?.alongside"
                >
                </app-material-offset-date-time>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-6">
                <app-material-offset-date-time
                  name="Commenced Pumping"
                  label="Commenced Pumping"
                  type="datetime-local"
                  [zoneId]="selectedPortOrganisation?.timezone!"
                  [(ngModel)]="bunkeringDeliveryNote.sof!.commencedPumping"
                  [minDate]="bunkeringDeliveryNote?.sof?.hoseConnected?.isoDate!"
                  [maxDate]="bunkeringDeliveryNote?.date?.isoDate!"
                  [disabled]="!selectedPortOrganisation || !bunkeringDeliveryNote?.sof?.hoseConnected"
                >
                </app-material-offset-date-time>
              </div>
              <div class="form-group row">
                <app-material-offset-date-time
                  name="Completed Pumping"
                  label="Completed Pumping"
                  type="datetime-local"
                  [zoneId]="selectedPortOrganisation?.timezone ?? 'UTC'"
                  [(ngModel)]="bunkeringDeliveryNote.sof!.hoseDisconnected!"
                  [minDate]="bunkeringDeliveryNote.sof?.completedPumping?.isoDate  ?? ''"
                  [maxDate]="bunkeringDeliveryNote.date?.isoDate  ?? ''"
                  [disabled]="!selectedPortOrganisation || !bunkeringDeliveryNote.sof!.completedPumping"
                  >
                </app-material-offset-date-time>
              </div>
              <div class="form-group row">
                <app-material-chunk-file-uploader
                  [accept]="'.pdf'"
                  name="fuelAnalysis"
                  id="fuelAnalysis"
                  [label]="'Fuel Analysis'"
                  [ngModel]="doc2"
                  (ngModelChange)="uploadFuelAnalysis($event)"
                  tabindex="20">
                </app-material-chunk-file-uploader>
              </div>
              <div class="form-group row ">
                <div class="d-flex justify-content-end gap-1">
                  @if (disable) {
                    <app-material-pg-button
                      [id]="'delete'"
                      [disabled]="!BunkeringDeliveryNote.form.valid && !valid"
                      label="Remove"
                      (clicked)="remove()">
                    </app-material-pg-button>
                  }
                  <app-material-pg-button
                    [id]="'submit'"
                    [disabled]="!BunkeringDeliveryNote.form.valid && !valid"
                    [label]="'save'"
                    (clicked)="save()">
                  </app-material-pg-button>
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow-sm">
            <div class="card-header">
              <h3 class="card-title">Fuel Analysis</h3>
            </div>
            <div class="card-body">
              <div class="col-md-12">
                <table
                  class="table table-sm table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (object of bunkeringDeliveryNote.fuelFileIds ; track $index; let i = $index) {
                      <tr
                        >
                        <td>{{i + 1}}</td>
                        <td>
                          <a (click)="downloadFile(object)"> <i
                          class="fa fa-download" aria-hidden="true"></i></a>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </div>
        </form>
      </fieldset>
    </div>

    @if (bunkeringDeliveryNote && bunkeringDeliveryNote.fileId) {
      <div class="col-md-6"
        >
        <app-material-pdf-viewer [fileId]="bunkeringDeliveryNote.fileId"></app-material-pdf-viewer>
      </div>
    }
  </div>
}